<template>
    <b-modal id="modal-cadastrar-editar" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true" @hide="fecharModal">
      <template slot="modal-header">
      <h5 class="modal-title" v-if="edicao">Editar {{ tipoClassificacaoNome }}</h5>
      <h5 class="modal-title" v-else>Cadastrar {{ tipoClassificacaoNome }}</h5>
      <button type="button" class="close" aria-label="Close" @click="fecharModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <fieldset>
      <div class="row">
        <div class="col-12">
          <form-group id="descricao" :field="$v.classificacao.descricao" :text="{ required: 'Obrigatório informar ' + campoDescricaoNome }">
            <label>{{campoDescricaoNome + ' *'}}</label>
            <input type="text" v-model="classificacao.descricao" class="form-control" />
          </form-group>
          <form-group v-if="tipoComComplemento" id="nome" :field="$v.classificacao.nome" :text="{ required: 'Obrigatório informar ' + campoComplementoNome }">
            <label>{{ campoComplementoNome + ' *' }}</label>
            <input type="text" v-model="classificacao.nome" class="form-control" />
          </form-group>
          <form-group v-if="possuiTipoFonte" id="tipo_fonte" :field="$v.classificacao.tipoFonteId">
            <label for="tipo_fonte">Tipo Fonte *</label>
            <select class="form-control" v-model="classificacao.tipoFonteId"  :text="{ required: 'Obrigatório informar o tipo da fonte' }">
              <option v-if="tiposFontes.length > 0" value="">Selecione</option>
              <option v-for="tipo in tiposFontes" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
            </select>
          </form-group>
          <form-group v-if="possuiFonte" id="fonte" :field="$v.classificacao.fonteId" :text="{ required: 'Obrigatório informar a fonte' }">
            <label for="fonte">Fonte *</label>
            <select class="form-control" v-model="classificacao.fonteId">
              <option v-if="fontes.length > 0" value="">Selecione</option>
              <option v-for="fonte in fontes" :key="fonte.id" :value="fonte.id">{{ fonte.descricao }}</option>
            </select>
          </form-group>
          <form-group v-if="possuiPublicoAlvo" id="publico_alvo" :field="$v.classificacao.publicoId" :text="{ required: 'Obrigatório informar o publico alvo' }">
            <label for="publico_alvo">Publico Alvo *</label>
            <select class="form-control" v-model="classificacao.publicoId">
              <option v-if="publicoAlvo.length > 0" value="">Selecione</option>
              <option v-for="publico in publicoAlvo" :key="publico.id" :value="publico.id">{{ publico.publico }}</option>
            </select>
          </form-group>
        </div>
      </div>
      </fieldset>
      <div class="text-center" v-if="edicao">
        <a class="btn btn-secondary fa fa-trash" @click="excluir"></a>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="salvarTipo">Salvar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="fecharModal">Cancelar</a>
        </div>
      </div>
    </form>
    </b-modal>
</template>
<script>
import FormGroup from '@/core/components/FormGroup'
import { required, requiredIf } from 'vuelidate/lib/validators'
import Swal from 'sweetalert2'
import ConteudoAPI from '@/api/conteudo-api'
import ResponseUtils from '@/core/util/response-utils'
import Constants from '@/core/constants/constants'

export default {
  name: 'ModalCadastroEdicao',
  components: {
    FormGroup
  },
  props: {
    tipoClassificacaoNome: String,
    edicao: Boolean,
    idTipo: String,
    nomeTipo: String,
    tipoClassificacao: String,
    descricaoTipo: String,
    tiposFontes: Array,
    tipoFonte: String,
    publicoAlvo: Array,
    fontes: Array,
    fonte: String,
    publico: String
  },
  data () {
    return {
      classificacao: {
        nome: '',
        id: '',
        descricao: '',
        tipoFonteId: '',
        fonteId: '',
        publicoId: ''
      }
    }
  },
  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()
      this.classificacao.id = this.idTipo
      this.classificacao.nome = this.nomeTipo
      this.classificacao.descricao = this.descricaoTipo
      this.classificacao.tipoFonteId = ''
      if (typeof this.tipoFonte !== 'undefined') {
        this.classificacao.tipoFonteId = this.tipoFonte
      }
      this.classificacao.fonteId = ''
      if (typeof this.fonte !== 'undefined') {
        this.classificacao.fonteId = this.fonte
      }
      this.classificacao.publicoId = ''
      if (typeof this.publico !== 'undefined') {
        this.classificacao.publicoId = this.publico
      }
    })
  },
  validations: {
    classificacao: {
      descricao: { required },
      nome: { required: requiredIf(function () {
        if (parseInt(this.tipoClassificacao) === Constants.TIPO_SIMULADO) {
          return false
        }
        return true
      }) },
      tipoFonteId: { required: requiredIf(function () {
        if (parseInt(this.tipoClassificacao) === Constants.FONTE) {
          return true
        }
        return false
      }) },
      publicoId: { required: requiredIf(function () {
        if (parseInt(this.tipoClassificacao) === Constants.MODALIDADE) {
          return true
        }
        return false
      }) },
      fonteId: { required: requiredIf(function () {
        if (parseInt(this.tipoClassificacao) === Constants.MODALIDADE) {
          return true
        }
        return false
      }) }
    }
  },
  computed: {
    campoDescricaoNome () {
      let tipo = parseInt(this.tipoClassificacao)
      if (tipo === Constants.PUBLICO_ALVO) {
        return 'Público'
      }
      return 'Descrição'
    },
    campoComplementoNome () {
      let tipo = parseInt(this.tipoClassificacao)
      if (tipo === Constants.PUBLICO_ALVO) {
        return 'Sigla'
      }
      if (tipo === Constants.MODALIDADE) {
        return 'Modalidade'
      }
      if (tipo === Constants.FONTE) {
        return 'Fonte'
      }
      return 'Descrição'
    },
    tipoComComplemento () {
      let tipo = parseInt(this.tipoClassificacao)
      if (tipo === Constants.PUBLICO_ALVO || tipo === Constants.MODALIDADE || tipo === Constants.FONTE) {
        return true
      }
      return false
    },
    possuiTipoFonte () {
      let tipo = parseInt(this.tipoClassificacao)
      if (tipo === Constants.FONTE) {
        return true
      }
      return false
    },
    possuiFonte () {
      let tipo = parseInt(this.tipoClassificacao)
      if (tipo === Constants.MODALIDADE) {
        return true
      }
      return false
    },
    possuiPublicoAlvo () {
      let tipo = parseInt(this.tipoClassificacao)
      if (tipo === Constants.MODALIDADE) {
        return true
      }
      return false
    }
  },
  methods: {
    show: function () {
      this.$bvModal.show('modal-cadastrar-editar')
    },
    salvarTipo: function () {
      this.$v.classificacao.$touch()
      if (!this.$v.classificacao.$invalid) {
        const loader = this.$loading.show()
        if (this.edicao) {
          let params = {
            descricao: this.classificacao.descricao,
            id: this.classificacao.id,
            nome: this.classificacao.nome,
            tipoFonteId: this.classificacao.tipoFonteId,
            fonteId: this.classificacao.fonteId,
            publicoId: this.classificacao.publicoId
          }
          ConteudoAPI.editarTipo(params, this.tipoClassificacao).then(data => {
            loader.hide()

            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: this.tipoClassificacaoNome + ' editado com sucesso'
            }).then(() => {
              this.$bvModal.hide('modal-cadastrar-editar')
              this.$emit('tipoSalvo', this.tipoClassificacao)
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
        } else {
          let params = {
            descricao: this.classificacao.descricao,
            id: this.classificacao.id,
            nome: this.classificacao.nome,
            tipoFonteId: this.classificacao.tipoFonteId,
            fonteId: this.classificacao.fonteId,
            publicoId: this.classificacao.publicoId
          }
          ConteudoAPI.cadastrarTipo(params, this.tipoClassificacao).then(data => {
            loader.hide()

            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: this.tipoClassificacaoNome + ' cadastrado com sucesso'
            }).then(() => {
              this.$bvModal.hide('modal-cadastrar-editar')
              this.$emit('tipoSalvo', this.tipoClassificacao)
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
        }
      }
    },
    fecharModal: function () {
      this.$bvModal.hide('modal-cadastrar-editar')
      this.$emit('tipoSalvo', this.tipoClassificacao)
    },
    excluir: function () {
      Swal.fire({
        title: 'Você deseja excluir ' + this.descricaoTipo + ' ?',
        text: 'Essa ação não poderá ser revertida!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          ConteudoAPI.excluirTipo(this.idTipo, this.tipoClassificacao).then(data => {
            loader.hide()
            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: this.tipoClassificacaoNome + ' excluido com sucesso'
            }).then(() => {
              this.$bvModal.hide('modal-cadastrar-editar')
              this.$emit('tipoSalvo', this.tipoClassificacao)
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
        }
      })
    }
  }
}
</script>
